import { request } from 'react-common'
import { PlatformUser } from 'types'
import { ObjectiveWorkflowId } from '@/api/models/aggregate'
import { Activity } from './activity'

export interface ActivityRecord {
  id: string
  score: number
  maxScore: number
  normalizedScore: number
  grade: string
  gradeColor: string
  progress: number
  activity: Activity
  user: PlatformUser
  created: string
  started: string
  submitted: string
  finished: string
  activityWorkflowId?: string
  passed?: boolean
}

export class ActivityRecordApi {
  private static readonly api = request('users/me/objective-workflows/:ow_id/activity-records/query')

  static query({
    queries,
    objectiveWorkflowId,
  }: {
    objectiveWorkflowId: ObjectiveWorkflowId
    queries: Record<string, any>
  }) {
    return this.api
      .get({ url: { ow_id: objectiveWorkflowId }, query: queries })
      .then((res) => res.body.data as ActivityRecord[])
  }
}
